module.exports = require("/opt/atlassian/pipelines/agent/build/src/state/createStore.js")